/**
 * @file isClient
 * @author yuzong(yuzong@tencent.com)
 */
import { getDefaultElementSize, isClient } from '@tencent/glue-util-boundary';
export function getWindowSize() {
  if (!isClient()) {
    return getDefaultElementSize();
  }

  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
}